export default __webpack_public_path__ + "static/media/slide-DD-Xpress.64fbd4de.png";